module.exports = __webpack_public_path__ + "static/media/coffee.d7cd49a0.svg";